// Start global url variables
const FACEBOOK_LINK_URL = `${BASE_URL}/members/api/auth/facebook/link`;
const LINKEDIN_LINK_URL = `${BASE_URL}/members/api/auth/linkedin/link`;
const GOOGLE_LINK_URL = `${BASE_URL}/members/api/auth/google/link`;

const MAIN_SOCIAL_NETWORK_UNLINK_URL = `${BASE_URL}/members/api/auth/unlink`;

const GOOGLE_SIGN_UP_URL = `${BASE_URL}/members/api/auth/google/signup`;
const GOOGLE_SIGN_IN_URL = `${BASE_URL}/members/api/auth/google/signin`;

const LINKEDIN_SIGN_UP_URL = `${BASE_URL}/members/api/auth/linkedin/signup`;
const LINKEDIN_SIGN_IN_URL = `${BASE_URL}/members/api/auth/linkedin/signin`;

const FACEBOOK_SIGN_UP_URL = `${BASE_URL}/members/api/auth/facebook/signup`;
const FACEBOOK_SIGN_IN_URL = `${BASE_URL}/members/api/auth/facebook/signin`;

const UPDATE_USER_AVATAR_URL = `${BASE_URL}/members/api/member/image/upload`;
const UPDATE_USER_DATA_URL = `${BASE_URL}/members/api/member`;

// End global url variables 

// Start disabled facebook message
// TODO remove this constants after facebook approvement
const facebookDisabledButtonNotification = 'Цей функціонал ще в розробці й з\'явиться найближчим часом';
const facebookDisabledNotificationType = 'info';
const facebookDisabledLinkButtonClass = 'facebook-disabled';

// End disabled facebook message



document.addEventListener('DOMContentLoaded', () => {

    //  Start basic functions

    const addClass = (element, activeClass) => {
        element?.classList.add(activeClass);
    };

    const removeClass = (element, activeClass) => {
        element?.classList.remove(activeClass);
    };

    const toggleClass = (element, activeClass) => {
        element?.classList.toggle(activeClass);
    };

    // End basic functions

    // Start handling adaptive header

    const headerBurgerButton = document.querySelector('#header-burger-button');
    const headerBurgerActiveClass = 'close';
    const headerPopupMenuActiveClass = 'open';

    const middleScreenHeaderNavigation = document.querySelector('.gh-head-desktop-navigation');
    const mobileHeaderMenu = document.querySelector('.gh-head-actions-box');

    const handleClickOutsideMobileMenu = (event) => {
        const hasBurgerButtonActiveClass = headerBurgerButton.classList.contains(headerBurgerActiveClass);
        const hasClickOutsideMobileMenu = (!middleScreenHeaderNavigation.contains(event.target) || !mobileHeaderMenu.contains(event.target)) && event.target !== headerBurgerButton;

        if (hasBurgerButtonActiveClass && hasClickOutsideMobileMenu) {
            closeMobileMenu();
        }
    }

    const openMobileMenu = () => {
        addClass(headerBurgerButton, headerBurgerActiveClass);
        addClass(middleScreenHeaderNavigation, headerPopupMenuActiveClass);
        addClass(bodyElement, actionBodyClass);
        addClass(mobileHeaderMenu, headerPopupMenuActiveClass);
    };

    const closeMobileMenu = () => {
        removeClass(headerBurgerButton, headerBurgerActiveClass);
        removeClass(middleScreenHeaderNavigation, headerPopupMenuActiveClass);
        removeClass(bodyElement, actionBodyClass);
        removeClass(mobileHeaderMenu, headerPopupMenuActiveClass);
    };

    headerBurgerButton?.addEventListener('click', (event) => {
        const isBurgerButtonActive = event.target.classList.contains(headerBurgerActiveClass);
        if (isBurgerButtonActive) {
            closeMobileMenu();
            return;
        }
        openMobileMenu();
    });

    document?.addEventListener('click', handleClickOutsideMobileMenu);

    // End handling adaptive header

    //  Start notification handling

    const notificationCloseButton = document.querySelector('#close-notification-button');
    const notificationElement = document.querySelector('#notification');

    const notificationElementActiveClass = 'open';
    const notificationElementErrorClass = 'error';
    const notificationElementSuccessClass = 'success';
    const baseNotificationMessage = 'На жаль, сталася системна помилка.';

    const hideNotificationMessage = () => {
        removeClass(notificationElement, notificationElementActiveClass);
    };

    const showNotificationMessage = (notificationType = '', messageText = baseNotificationMessage, duration = 5000) => {
        const textElement = document.querySelector('.notification-text');
        textElement.textContent = messageText;
        notificationElement.classList.add(notificationElementActiveClass, notificationType);
        setTimeout(() => {
            notificationElement.classList.remove(notificationElementActiveClass, notificationType);
            textElement.textContent = '';
        }, duration);
    }

    notificationCloseButton?.addEventListener('click', hideNotificationMessage);

    //  End notification handling

    // Start query string handling

    const queryString = window.location.search;

    if (queryString) {

        const queryParams = new URLSearchParams(queryString);
        const queryParamsAction = queryParams.get('action');
        const queryParamsSuccess = queryParams.get('success');
        const queryParamsError = queryParams.get('error');
        const queryParamsErrorPayload = queryParams.get('error_payload');
        const queryParamsSuccessBoolean = (/true/).test(queryParamsSuccess);

        const defaultErrorMessage = 'Вибачте, виникла помилка.';
        const authNotificationType = queryParamsSuccessBoolean ? notificationElementSuccessClass : notificationElementErrorClass;
        const noEmailMessage = 'Публічний доступ до вашої електронної пошти відсутній. Перевірте ваші налаштування.';
        const serverErrorMessage = 'Сталася системна помилка, спробуйте пізніше.';

        const notificationTextsCollection = {
            'signin': {
                'true': 'З поверненням на PROIT.UA!',
                'false': {
                    'signin_not_registered_sn': 'Акаунт не знайдено в системі. Будь ласка, зареєструйтесь.',
                    'signin_banned': 'На жаль, ви не можете увійти на сайт, тому що ваш обліковий запис було заблоковано через недотримання Правил спільноти.',
                    'no_email': noEmailMessage,
                    'server_error': serverErrorMessage
                }
            },
            'signup': {
                'true': 'Вітаємо на PROIT.UA!',
                'false': {
                    'signup_already_registered': 'Акаунт вже зареєстрований. Увійдіть, будь ласка, в систему.',
                    'signup_banned': 'На жаль, ви не можете зареєструватися на нашому сайті, тому що ваш обліковий запис було заблоковано через недотримання Правил спільноти.',
                    'no_email': noEmailMessage,
                    'server_error': serverErrorMessage
                }
            },
            'link': {
                'true': 'Соціальна мережа додана успішно.',
                'false': {
                    'link_banned': 'Ви не можете зв`язати даний акаунт, тому що його було заблоковано через недотримання Правил спільноти',
                    'sn_other_linked': 'Ви не можете зв`язати даний акаунт, оскільки він вже зареєстрований в системі',
                    'no_email': noEmailMessage,
                    'server_error': serverErrorMessage
                }
            }
        }

        const getErrorMessageWithPayload = (queryPayload) => {
            const payloadMessage = queryPayload.split(',');
            const paramsQueryAmount = 2;

            if (payloadMessage.length === paramsQueryAmount) {
                return `Дана електрона пошта ${payloadMessage[1].toUpperCase()} вже зареєстрована у системі, будь ласка, спробуйте увійти за допомогою ${payloadMessage[0].toUpperCase()}`;
            } else {
                return `Дана електрона пошта вже зареєстрована у системі, будь ласка, спробуйте увійти за допомогою ${payloadMessage[0].toUpperCase()}`;
            }
        }

        const getNotificationMessageText = (messageAction, messageSuccess, messageType, messagePayload, booleanMessageSuccess) => {
            let notificationMessageText = '';

            if (messagePayload) {
                notificationMessageText = getErrorMessageWithPayload(messagePayload);
            } else if (messageType) {
                notificationMessageText = notificationTextsCollection[messageAction][messageSuccess][messageType];
            } else {
                notificationMessageText = booleanMessageSuccess ? notificationTextsCollection[messageAction][messageSuccess] : defaultErrorMessage;
            }
            return notificationMessageText;
        }


        const authNotificationMessage = getNotificationMessageText(queryParamsAction, queryParamsSuccess, queryParamsError, queryParamsErrorPayload, queryParamsSuccessBoolean);

        if (queryParamsAction && queryParamsSuccess) {
            showNotificationMessage(authNotificationType, authNotificationMessage);
            history.replaceState(null, null, window.location.pathname);
        }

    }

    // End query string handling

    // Start linking accounts

    const facebookLinkButton = document.querySelector('#account-button-facebook');
    const googleLinkButton = document.querySelector('#account-button-google');
    const linkedinLinkButton = document.querySelector('#account-button-linkedin');
    const socialNetworkIdDataAttribute = 'data-social-id';

    const socialNetworkActionClass = 'selected';
    const customCheckboxElementClass = 'custom-checkbox';

    const successUnlinkMessage = 'Запит відправлено успішно';
    const errorUnlinkMessage = 'Сталася помилка, будь ласка спробуйте пізнише';

    const linkingSocialNetwork = (linkingUrl) => {
        location.href = linkingUrl;
    };

    const unlinkingSocialNetwork = async (unlinkingUrl, inlinkingId, targetButtonElement) => {
        try {
            const response = await fetch(`${unlinkingUrl}/${inlinkingId}`, {
                method: 'PUT',
            });
            if (response.ok) {
                showNotificationMessage(notificationElementSuccessClass, successUnlinkMessage);
                const currentCheckboxElement = targetButtonElement.querySelector(`.${customCheckboxElementClass}`);
                removeClass(targetButtonElement, socialNetworkActionClass);
                removeClass(currentCheckboxElement, socialNetworkActionClass);
                targetButtonElement.setAttribute(socialNetworkIdDataAttribute, '');

            } else {
                showNotificationMessage(notificationElementErrorClass, errorUnlinkMessage);
            }
        } catch (error) {
            showNotificationMessage(notificationElementErrorClass, errorUnlinkMessage);
        }
    };

    const handlingSocialLinking = (targetElement, linkingUrl, unlinkingUrl) => {
        const dataAttr = targetElement.getAttribute(socialNetworkIdDataAttribute);
        if (!dataAttr) {
            linkingSocialNetwork(linkingUrl);
            return;
        }
        unlinkingSocialNetwork(unlinkingUrl, dataAttr, targetElement);
    }

    // TODO after facebook approvement remove the comment and remove notification message
    facebookLinkButton?.classList.add(facebookDisabledLinkButtonClass);

    facebookLinkButton?.addEventListener('click', () => {
        // TODO after facebook approvement remove the comment and remove notification message
        // handlingSocialLinking(
        //     facebookLinkButton,
        //     FACEBOOK_LINK_URL,
        //     MAIN_SOCIAL_NETWORK_UNLINK_URL
        // );
        showNotificationMessage(facebookDisabledNotificationType, facebookDisabledButtonNotification);
    });

    linkedinLinkButton?.addEventListener('click', () => {
        handlingSocialLinking(
            linkedinLinkButton,
            LINKEDIN_LINK_URL,
            MAIN_SOCIAL_NETWORK_UNLINK_URL
        );
    });

    googleLinkButton?.addEventListener('click', () => {
        handlingSocialLinking(
            googleLinkButton,
            GOOGLE_LINK_URL,
            MAIN_SOCIAL_NETWORK_UNLINK_URL
        );
    });

    // End linking accounts

    // Start registration popup handling

    const headerSigninButton = document.querySelector('#gh-head-signin-button');
    const headerRegistrationButton = document.querySelector('#gh-head-registration-button');
    const registrationPopup = document.querySelector('.registration-substrate-layer');
    const signinPopup = document.querySelector('.signin-substrate-layer');


    const allBasePopups = document.querySelectorAll('.substrate-layer');
    const bodyElement = document.querySelector('body');

    const actionPopupClass = 'open';
    const actionBodyClass = 'hidden-scroll';

    const openBasePopup = (event, element, activeClass) => {
        const hasOpenMobileMenu = headerBurgerButton.classList.contains(headerBurgerActiveClass);
        if (hasOpenMobileMenu) {
            closeMobileMenu();
        }
        event.stopPropagation();
        addClass(element, activeClass);
        addClass(bodyElement, actionBodyClass);
    };

    const closeRegistrationPopup = (event, element, activeClass, closeButton) => {
        event.stopPropagation();
        if (event.target === element || event.target === closeButton) {
            removeClass(element, activeClass);
            removeClass(bodyElement, actionBodyClass);
        }
    };

    if (allBasePopups.length) {
        allBasePopups.forEach(singleBasePopup => {
            singleBasePopup?.addEventListener('click', (event) => {
                const singleCloseButton = singleBasePopup.querySelector('.base-popup-close-button');
                closeRegistrationPopup(event, singleBasePopup, actionPopupClass, singleCloseButton);
            });
        });
    }

    if (headerSigninButton && headerRegistrationButton) {
        headerRegistrationButton?.addEventListener('click', (event) => {
            openBasePopup(event, registrationPopup, actionPopupClass);
        });

        headerSigninButton?.addEventListener('click', (event) => {
            openBasePopup(event, signinPopup, actionPopupClass);
        });
    }

    // End registration popup handling

    // Start remove account popup handling

    const removeAccountButton = document.querySelector('#remove-account-button');
    const cancelRemoveAccountButton = document.querySelector('#cancel-remove-popup-button');
    const removeAccountPopup = document.querySelector('.remove-account-substrate-layer');

    removeAccountButton?.addEventListener('click', (event) => {
        openBasePopup(event, removeAccountPopup, actionPopupClass);
    });

    cancelRemoveAccountButton?.addEventListener('click', () => {
        removeClass(removeAccountPopup, actionPopupClass);
        removeClass(bodyElement, actionBodyClass);
    });

    // End remove account popup handling

    // Start social auth handling

    const authSocialHandler = (authSocialUrl) => {
        location.href = authSocialUrl;
    }

    //  End social auth handling

    // Start google auth

    const googleSignUpButton = document.querySelector('#google-registration');

    googleSignUpButton?.addEventListener('click', () => {
        authSocialHandler(GOOGLE_SIGN_UP_URL);
    });

    const googleSingInButton = document.querySelector('#google-signin');

    googleSingInButton?.addEventListener('click', () => {
        authSocialHandler(GOOGLE_SIGN_IN_URL);
    });

    // End google auth

    // Start linkedIn auth

    const linkedInSignUpButton = document.querySelector('#linkedin-registration');

    linkedInSignUpButton?.addEventListener('click', () => {
        authSocialHandler(LINKEDIN_SIGN_UP_URL);
    });

    const linkedInSingInButton = document.querySelector('#linkedin-signin');

    linkedInSingInButton?.addEventListener('click', () => {
        authSocialHandler(LINKEDIN_SIGN_IN_URL);
    });

    // End linkedIn auth


    // Start facebook auth

    const facebookSignUpButton = document.querySelector('#facebook-registration');

    facebookSignUpButton?.addEventListener('click', () => {
        // TODO after facebook approvement remove the comment and remove notification message
        // authSocialHandler(FACEBOOK_SIGN_UP_URL);
        showNotificationMessage(facebookDisabledNotificationType, facebookDisabledButtonNotification);
    });

    const facebookSingInButton = document.querySelector('#facebook-signin');

    facebookSingInButton?.addEventListener('click', () => {
        // TODO after facebook approvement remove the comment and remove notification message
        // authSocialHandler(FACEBOOK_SIGN_IN_URL);
        showNotificationMessage(facebookDisabledNotificationType, facebookDisabledButtonNotification);
    });

    // End facebook auth


    //  Start member popup handling

    const headerMemberButton = document.querySelector('#header-member-button');
    const headerMemberPopup = document.querySelector('#header-member-popup');
    const additionalActionMemberClass = 'open';

    const openMemberPopup = () => {
        addClass(headerMemberButton, additionalActionMemberClass);
        addClass(headerMemberPopup, additionalActionMemberClass);
    };

    const closeMemberPopup = () => {
        removeClass(headerMemberButton, additionalActionMemberClass);
        removeClass(headerMemberPopup, additionalActionMemberClass);
    };

    const closeMemberPopupByClickOutside = (event) => {
        if (event.target !== headerMemberButton) {
            closeMemberPopup();
        }
    };

    const handleHeaderMemberButtonClick = () => {
        const hasPopupActionClass = headerMemberButton.classList.contains(additionalActionMemberClass);
        if (hasPopupActionClass) {
            closeMemberPopup();
        } else {
            openMemberPopup();
        }
    }

    document?.addEventListener('click', closeMemberPopupByClickOutside);

    headerMemberButton?.addEventListener('click', handleHeaderMemberButtonClick);

    //  End member popup handling

    // Start handling image downloading

    const avatarChangeButton = document.querySelector('.personal-page-avatar-button');
    const avatarDownloadInput = document.querySelector('.personal-page-avatar-input');

    const mainAvatarImage = document.querySelector('#avatar-image');
    const headerAvatarImage = document.querySelector('.gh-head-member-avatar');

    const imageLoader = document.querySelector('.lds-default');
    const loaderActiveClass = 'open';

    const successImageMessage = 'Фото успішно завантажене';
    const errorImageMessage = 'Сталася помилка, перезавантажте сторінку та спробуйте пізніше';
    const errorImageValidationMessage = 'Фото не відповідає зазначеним вимогам: максимальний розмір 20мб, формат: jpg, png, gif';

    let selectedImage = null;

    const fetchingImage = async (imageFile) => {
        const formData = new FormData();
        formData.append('file', imageFile);

        try {
            addClass(imageLoader, loaderActiveClass);
            const response = await fetch(UPDATE_USER_AVATAR_URL, {
                method: 'POST',
                body: formData,
            });
            if (response.ok) {
                const { member_photo } = await response.json();
                if (!member_photo[0]) {
                    showNotificationMessage(notificationElementErrorClass, errorImageMessage);
                    removeClass(imageLoader, loaderActiveClass);
                    return;
                }
                showNotificationMessage(notificationElementSuccessClass, successImageMessage);
                removeClass(imageLoader, loaderActiveClass);
                mainAvatarImage?.setAttribute('src', member_photo[0]);
                headerAvatarImage?.setAttribute('src', member_photo[0]);
                selectedImage = null;
            } else {
                showNotificationMessage(notificationElementErrorClass, errorImageMessage);
                removeClass(imageLoader, loaderActiveClass);
                selectedImage = null;
            }
        } catch (error) {
            showNotificationMessage(notificationElementErrorClass, errorImageMessage);
            imageFile.value = null;
        }
    }

    const uploadingUserImage = (event) => {
        selectedImage = event.target.files[0];
        const imageSizeRequirements = 20971520;
        const isValidImageType = selectedImage.name.match(/.+(.jpg|.png|.gif)$/gm);
        const isValidImageSize = selectedImage.size < imageSizeRequirements;
        const isImageValid = isValidImageType && isValidImageSize;

        if (!isImageValid) {
            showNotificationMessage(notificationElementErrorClass, errorImageValidationMessage);
            selectedImage = null;
            return;
        }
        fetchingImage(selectedImage);
    }

    avatarChangeButton?.addEventListener('click', () => {
        avatarDownloadInput.click();
    });

    avatarDownloadInput?.addEventListener('change', (event) => {
        uploadingUserImage(event);
    });

    // End handling image downloading

    // Start handling checkbox for notifications
    // TODO: Uncomment if post comments will be allowed
    // const emailNotificationCheckbox = document.querySelector('#enable_comment_notifications');

    // emailNotificationCheckbox?.addEventListener('change', (event) => {
    //     const targetCheckbox = event.target;
    //     if (targetCheckbox.checked) {
    //         targetCheckbox.value = true;
    //     } else {
    //         targetCheckbox.value = false;
    //     }
    // });

    // End handling checkbox for notifications

    // Start submiting personal form

    const personalForm = document.querySelector('#personal-form');
    const formValidationScheme = {
        'required-text-field': /^(?!.*\s{2,})[a-zA-Zа-яА-Яє-їЄ-Ї\.|\-|'|`|\s]{2,30}$/,
        'text-field': /^$|^(?!.*\s{2,})[a-zA-Zа-яА-Яє-їЄ-Ї-0-9\.|\-|\s|!|@|\#|$|:|&|(|)|.|'|"|`|]{2,30}$/,
        'github-field': /^$|^(http(s?):\/\/)?(www\.)?github\.([a-z])+\/([A-Za-z0-9|-]{1,})+\/?$/
    };
    const errorInputElementClass = 'error';

    const successFormMessage = 'Запит відправлено успішно';
    const errorFormMessage = 'Сталася помилка, будь ласка спробуйте пізнише';

    const updateUserData = async (requestUrl, requestBody) => {
        try {
            const response = await fetch(requestUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });
            if (response.ok) {
                showNotificationMessage(notificationElementSuccessClass, successFormMessage);
            } else {
                showNotificationMessage(notificationElementErrorClass, errorFormMessage);
            }
        } catch (error) {
            showNotificationMessage(notificationElementErrorClass, errorFormMessage);
        }
    }

    personalForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        let allInputsValidationArray = [];
        const allInputs = personalForm.querySelectorAll('input[type="text"]');

        allInputs.forEach(singleInput => {

            const dataAttr = singleInput.getAttribute('data-form-validation');
            const isSingleInputValid = formValidationScheme[dataAttr].test(singleInput.value.trim());

            if (isSingleInputValid) {
                singleInput.parentElement.classList.remove(errorInputElementClass);
                allInputsValidationArray.push(true);
            } else {
                allInputsValidationArray.push(false);
                singleInput.parentElement.classList.add(errorInputElementClass);
            }
        });

        const isFormValid = allInputsValidationArray.every(item => item === true);

        if (!isFormValid) {
            const firstInvalidInputIndex = allInputsValidationArray.indexOf(false);
            const firstInvalidInputElement = allInputs[firstInvalidInputIndex];
            firstInvalidInputElement.tabIndex = 1;
            firstInvalidInputElement.focus();
        }

        if (isFormValid) {
            const personFormData = {};
            const allFormInputs = personalForm.querySelectorAll('input');
            allFormInputs.forEach(singleInput => {
                if (singleInput.id === 'email') {
                    return;
                }
                // TODO: Uncomment if post comments will be allowed
                // if (singleInput.id === 'enable_comment_notifications') {
                //     personFormData[singleInput.id] = singleInput.value === 'true' ? true : false;
                //     return;
                // }
                personFormData[singleInput.id] = singleInput.value.trim();
            });
            updateUserData(UPDATE_USER_DATA_URL, personFormData);
        }
    });

    // End submiting personal form

    // Start handling button scroll up

    const buttonScrollTop = document.querySelector(".scroll-up-button");
    const buttonVisibleClass = 'visible';
    const minScrollHeight = 300;

    window.addEventListener('scroll', () => {
        if (document.body.scrollTop > minScrollHeight || document.documentElement.scrollTop > minScrollHeight) {
            addClass(buttonScrollTop, buttonVisibleClass);
        } else {
            removeClass(buttonScrollTop, buttonVisibleClass);
        }
    });

    buttonScrollTop?.addEventListener('click', () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        removeClass(buttonScrollTop, buttonVisibleClass);
    });

    // End handling button scroll up

    // Start removing ghost default signup

    const removingDefaultPortalPopup = () => {
        const defaultGhostPortal = document.querySelector('#ghost-portal-root');

        defaultGhostPortal?.remove();
    }

    // End removing ghost default signup

    removingDefaultPortalPopup();

    // Start removing padding from twitter parent element

    const twitterElements = document.querySelectorAll('.twitter-tweet');

    if (twitterElements.length) {
        twitterElements.forEach((singleTwitterElement) => {
            singleTwitterElement.parentElement.style.paddingTop = 0;
        });
    }

    // End removing padding from twitter parent element

    // Start hiding external links

    const commercialDataAttr = 'data-commercial-link';
    const relLinkValues = ['nofollow', 'noopener', 'noreferrer'];
    const linkTargetAttr = 'target';
    const linkTargetAttrValue = '_blank';
    const linkRelArrt = 'rel';

    const postContentContainer = document.querySelector('.single-post-page-content');

    if (postContentContainer) {
        const allLinks = postContentContainer.querySelectorAll('a');
        const isLinksExist = allLinks.length > 0;

        if (isLinksExist) {

            allLinks.forEach((singleLink) => {
                const linkHrefAttr = singleLink.getAttribute('href');
                const hasLinkBaseUrl = linkHrefAttr.includes(BASE_URL);
                const hasLinkDataCommercialAttr = singleLink.hasAttribute(commercialDataAttr);
                const linkRelAttributeValues = !hasLinkDataCommercialAttr ? relLinkValues.join(' ') : `${relLinkValues[1]} ${relLinkValues[2]}`;

                if (!hasLinkBaseUrl) {
                    singleLink.setAttribute(linkTargetAttr, linkTargetAttrValue);
                    singleLink.setAttribute(linkRelArrt, linkRelAttributeValues);
                }
            });
        }
    }

    // End hiding external links

    // Start copy link handling

    const copyLinkButton = document.querySelector('#copy-link-button');
    const copyLinkButtonDataAttr = 'data-link-copy';
    const errorCopyLinkNotificationText = 'Нажаль сталася помилка копіювання'
    const successCopyLinkNotificationText = 'Посилання успішно скопійовано';

    const copyLinkToClipboard = async () => {

        const postUrl = copyLinkButton.getAttribute(copyLinkButtonDataAttr);
        navigator.clipboard.writeText(postUrl);

        const mozillaBrowserIdentifier = new RegExp(/firefox/i);
        const isMozillaBrowser = mozillaBrowser = mozillaBrowserIdentifier.test(navigator.userAgent);

        if (isMozillaBrowser) {
            showNotificationMessage('success', successCopyLinkNotificationText);
            return;
        }

        const clipboardUrl = await navigator.clipboard.readText();

        if (clipboardUrl) {
            showNotificationMessage('success', successCopyLinkNotificationText);
        } else {
            showNotificationMessage('error', errorCopyLinkNotificationText);
        }
    }

    copyLinkButton?.addEventListener('click', copyLinkToClipboard);

    // End copy link handling

    // Start updating img alt attribute

    const pageImages = document.querySelectorAll('.single-post-page-content img');
    const titleTag = document.querySelector('title');

    if (pageImages.length) {
        pageImages.forEach((image) => {
            const altAttribute = image.getAttribute('alt');
            if (altAttribute !== '') {
                return;
            }
            image.setAttribute('alt', titleTag.textContent);
        })
    }


    // End updating img alt attribute

    // Start updating social links attributes

    const allSocialLinks = document.querySelectorAll('.social-navigation .nav li a');

    if (!!allSocialLinks?.length) {
        allSocialLinks.forEach((link) => {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        });
    }

    // End updating social links attributes

});

